// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent {
  border: 1px solid var(--accent-color);
  border-radius: 8px;
  min-height: 58px;
  padding: 10px;
}

.item-selectable-article {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  height: max-content;
  word-break: break-word;
  transition: background 200ms linear;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
}
.item-selectable-article.row {
  flex-direction: row;
}
.item-selectable-article.row ion-img {
  display: none;
}
.item-selectable-article.row .footer-block {
  width: auto;
  gap: 5px;
}
.item-selectable-article .footer-block {
  display: flex;
  align-items: center;
  gap: 5px;
}
.item-selectable-article .footer-block .width-item {
  width: 20px;
}
.item-selectable-article .footer-block .option-item {
  font-size: 12px;
  height: 16px;
}
.item-selectable-article .footer-block .option-price {
  white-space: nowrap;
  margin-right: 5px;
}
.item-selectable-article .footer-block .option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}
.item-selectable-article .footer-block .added-item {
  display: flex;
  justify-content: flex-end;
  min-width: 20px;
}
.item-selectable-article .footer-block .added-item .selected-circle {
  border-radius: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon {
  visibility: none;
  opacity: 0;
  font-size: 14px;
  transition: opacity 500ms ease-in-out;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon.selected {
  visibility: visible;
  opacity: 1;
}

.info-icon {
  position: absolute;
  height: 20px;
  width: 20px;
  top: 14px;
  right: 14px;
  z-index: 2;
}

.item-selectable-article-image {
  margin: 0 auto;
  max-height: 40px;
  height: 100%;
  width: auto;
  max-width: 100%;
}

.quantity-selector {
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin: auto;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: auto;
  width: 13px;
  height: 13px;
}
.quantity-selector .quantity-btn {
  width: 22px;
  height: 22px;
  margin: 0px 6px;
  cursor: pointer;
  background: #fff;
  border-radius: 4px;
  display: flex;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.text-wrapper {
  display: flex;
  text-align: start;
  margin-right: auto;
  margin-left: 15px;
  max-width: 58%;
}

.desc {
  letter-spacing: 0.02em;
  line-height: 150%;
  position: relative;
  max-height: 1.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 55px;
  padding-right: 10px;
  transform: translateY(-5px);
}
.desc.expanded {
  max-height: 300px;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss"],"names":[],"mappings":"AAGA;EACE,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AASE;EACE,mBAAA;AAPJ;AASI;EACE,aAAA;AAPN;AAUI;EACE,WAAA;EACA,QAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAVJ;AAYI;EACE,WAAA;AAVN;AAaI;EACE,eAAA;EACA,YAAA;AAXN;AAeI;EACE,mBAAA;EACA,iBAAA;AAbN;AAeM;EACE,gBAAA;EACA,gBAAA;AAbR;AAiBI;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AAfN;AAiBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAfR;AAiBQ;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,qCAAA;AAfV;AAiBU;EACE,mBAAA;EACA,UAAA;AAfZ;;AAwBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AArBF;;AAyBA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAtBF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA3BF;AA6BE;EACE,YAAA;EACA,WAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AA5BJ;AA8BI;EACE,YAAA;AA5BN;;AAiCA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;AA9BF;AAgCE;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AA9BJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n\n.parent {\n  border: 1px solid var(--accent-color);\n  border-radius: 8px;\n  min-height: 58px;\n  padding: 10px;\n}\n\n.item-selectable-article {\n  position: relative;\n  margin: 0 auto;\n  flex-grow: 1;\n  height: max-content;\n  word-break: break-word;\n  transition: background 200ms linear;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: transparent;\n\n  &.selected {\n    //background: #EBDFDA;\n    //border: 1px solid var(--color-black);\n  }\n\n  &.row {\n    flex-direction: row;\n\n    ion-img {\n      display: none;\n    }\n\n    .footer-block {\n      width: auto;\n      gap: 5px;\n    }\n  }\n\n  .footer-block {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    .width-item {\n      width: 20px;\n    }\n\n    .option-item {\n      font-size: 12px;\n      height: 16px;\n\n    }\n\n    .option-price {\n      white-space: nowrap;\n      margin-right: 5px;\n\n      &.no-price {\n        min-height: 12px;\n        max-height: 12px;\n      }\n    }\n\n    .added-item {\n      display: flex;\n      justify-content: flex-end;\n      min-width: 20px;\n\n      .selected-circle {\n        border-radius: 4px;\n        width: 22px;\n        height: 22px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n\n        ion-icon {\n          visibility: none;\n          opacity: 0;\n          font-size: 14px;\n          transition: opacity 500ms ease-in-out;\n\n          &.selected {\n            visibility: visible;\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.info-icon {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  top: 14px;\n  right: 14px;\n  z-index: 2;\n}\n\n\n.item-selectable-article-image {\n  margin: 0 auto;\n  max-height: 40px;\n  height: 100%;\n  width: auto;\n  max-width: 100%;\n}\n\n// app-quantity-selector {\n//   filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n// }\n\n\n.quantity-selector {\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  margin: auto;\n  z-index: 999;\n\n  ion-icon {\n    margin: auto;\n    width: 13px;\n    height: 13px;\n  }\n\n  .quantity-btn {\n    width: 22px;\n    height: 22px;\n    margin: 0px 6px;\n    cursor: pointer;\n    background: #fff;\n    border-radius: 4px;\n    display: flex;\n\n    &.add-opacity {\n      opacity: 0.5;\n    }\n  }\n}\n\n.text-wrapper {\n  display: flex;\n  text-align: start;\n  margin-right: auto;\n  margin-left: 15px;\n  max-width: 58%;\n}\n\n.desc {\n  letter-spacing: 0.02em;\n  line-height: 150%;\n  position: relative;\n  max-height: 1.4em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 55px;\n  padding-right: 10px;\n  transform: translateY(-5px);\n\n  &.expanded {\n    max-height: 300px;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
